import {
  DRUM_PAD_COUNT,
  cloneDrumKit,
  isGenericDrumPadName,
  normalizeDrumKit,
  type DrumKit,
  type DrumPad,
} from "../../../../src/lib/audio";

/** Assign library samples to consecutive pads starting at `startIndex`. */
export function assignSamplesToDrumPads(
  kit: DrumKit,
  startIndex: number,
  samples: readonly { id: string; name: string }[],
): DrumKit {
  if (samples.length === 0) {
    return normalizeDrumKit(kit);
  }
  const next = cloneDrumKit(normalizeDrumKit(kit));
  next.mode = "sample";
  const start = Math.max(0, Math.min(DRUM_PAD_COUNT - 1, Math.floor(startIndex)));
  for (let i = 0; i < samples.length; i++) {
    const padIndex = start + i;
    if (padIndex >= DRUM_PAD_COUNT) {
      break;
    }
    const sample = samples[i]!;
    const prev = next.pads[padIndex]!;
    const pad: DrumPad = {
      ...prev,
      sampleId: sample.id,
      level: prev.level > 0 ? prev.level : 0.85,
      decayMs: prev.decayMs > 0 ? prev.decayMs : 180,
      pitchSemis: prev.pitchSemis ?? 0,
    };
    delete pad.region;
    if (isGenericDrumPadName(prev.name) || !prev.name.trim()) {
      pad.name = sample.name.slice(0, 24);
    }
    next.pads[padIndex] = pad;
  }
  return normalizeDrumKit(next);
}

export function clearDrumPadSample(kit: DrumKit, padIndex: number): DrumKit {
  const next = cloneDrumKit(normalizeDrumKit(kit));
  const pad = next.pads[padIndex];
  if (!pad) {
    return next;
  }
  const { sampleId: _drop, region: _region, ...rest } = pad;
  next.pads[padIndex] = { ...rest, pitchSemis: pad.pitchSemis ?? 0 };
  return normalizeDrumKit(next);
}
